import { Transaction } from '~/types/transaction';

export const getComplementaryInternalTransfer = (
  relatedTransactions: Transaction[],
  currentTransactionId?: Transaction['id'] | null,
): Transaction | null => {
  if (relatedTransactions.length !== 2 || !currentTransactionId) return null;

  return relatedTransactions.find((t) => t.id !== currentTransactionId) ?? null;
};
